import { type Finding } from '@consigli/types';

import {
  type DeliverablePayload,
  parseDeliverablePayload,
} from '@/pages/insight/dashboard/rfp/rfp-requirements-accordion';

/*
 * Parsed once per finding object. RTK Query hands back the same objects until
 * the response changes, and every card render and search keystroke reads them.
 */
const payloads = new WeakMap<Finding, DeliverablePayload | null>();

export const requirementPayload = (finding: Finding): DeliverablePayload | null => {
  const cached = payloads.get(finding);
  if (cached !== undefined) return cached;
  const payload = parseDeliverablePayload(finding);
  payloads.set(finding, payload);
  return payload;
};

/**
 * The RFP dashboard's own rule for showing a category: its payload parses and
 * holds at least one item. One the dashboard hides is not offered here either.
 */
export const isListedRequirement = (finding: Finding): boolean =>
  (requirementPayload(finding)?.deliverables.length ?? 0) > 0;

/** What a search matches: everything the card shows, opened or not. */
export const requirementSearchText = (finding: Finding): string => {
  const payload = requirementPayload(finding);
  if (!payload) return '';
  return [
    payload.category,
    payload.categoryDescription,
    ...payload.deliverables.flatMap((deliverable) => [
      deliverable.name,
      deliverable.description,
      deliverable.source ?? '',
    ]),
  ].join(' ');
};
